(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (reducir || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function initComparadores(raiz) {
    (raiz || document).querySelectorAll('.mt-ad__comp').forEach(function (comp) {
      if (comp.dataset.mtInit) return;
      comp.dataset.mtInit = '1';
      var rango = comp.querySelector('.mt-ad__rango');
      if (!rango) return;
      var pintar = function () { comp.style.setProperty('--mt-pos', rango.value + '%'); };
      rango.addEventListener('input', pintar);
      pintar();
    });
  }

  function initCalculadoras(raiz) {
    (raiz || document).querySelectorAll('[data-mt-calc]').forEach(function (calc) {
      if (calc.dataset.mtInit) return;
      calc.dataset.mtInit = '1';
      var veces = calc.querySelector('[data-mt-veces]');
      var coste = calc.querySelector('[data-mt-coste]');
      var outVeces = calc.querySelector('[data-mt-out-veces]');
      var outCoste = calc.querySelector('[data-mt-out-coste]');
      var cifra = calc.querySelector('[data-mt-cifra]');
      var precio = parseFloat(calc.dataset.mtPrecio) || 0;
      var moneda = calc.dataset.mtMoneda || '$';
      var actual = 0;
      var calcular = function () {
        var v = parseFloat(veces.value), c = parseFloat(coste.value);
        outVeces.textContent = v;
        outCoste.textContent = c + ' ' + moneda;
        var ahorro = Math.max(0, Math.round(v * 12 * c - precio));
        animar(actual, ahorro);
        actual = ahorro;
      };
      var animar = function (desde, hasta) {
        if (reducir) { cifra.textContent = hasta + ' ' + moneda; return; }
        var t0 = null;
        var paso = function (t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / 600);
          cifra.textContent = Math.round(desde + (hasta - desde) * (1 - Math.pow(1 - p, 3))) + ' ' + moneda;
          if (p < 1) requestAnimationFrame(paso);
        };
        requestAnimationFrame(paso);
      };
      veces.addEventListener('input', calcular);
      coste.addEventListener('input', calcular);
      calcular();
    });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq__pregunta').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (pp) {
      if (pp.dataset.mtInit) return;
      pp.dataset.mtInit = '1';
      var principal = pp.querySelector('.mt-pp__principal img');
      pp.querySelectorAll('.mt-pp__mini').forEach(function (mini) {
        mini.addEventListener('click', function () {
          pp.querySelectorAll('.mt-pp__mini').forEach(function (m) { m.classList.remove('mt-activa'); });
          mini.classList.add('mt-activa');
          principal.style.opacity = 0;
          setTimeout(function () { principal.src = mini.dataset.src; principal.style.opacity = 1; }, 180);
        });
      });

      var datos = pp.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var inputId = pp.querySelector('input[name="id"]');
      var precio = pp.querySelector('.mt-pp__actual');
      var tachado = pp.querySelector('.mt-pp__tachado');
      var boton = pp.querySelector('.mt-pp__form button[type="submit"]');
      var txtAgotado = boton ? boton.dataset.agotado : '';
      var txtComprar = boton ? boton.dataset.comprar : '';
      var formato = pp.dataset.mtFormato || '{{amount}}';
      var dinero = function (cent) {
        var n = (cent / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ',')).replace(/\{\{\s*\w+\s*\}\}/, n);
      };
      pp.querySelectorAll('.mt-pp__opcion input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          pp.querySelectorAll('.mt-pp__opcion').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
          if (!v) return;
          inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
          if (boton) { boton.disabled = !v.available; boton.firstChild.textContent = v.available ? txtComprar : txtAgotado; }
          if (v.featured_image && principal) { principal.src = v.featured_image.src; }
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initEscenarios(raiz) {
    (raiz || document).querySelectorAll('[data-mt-esc]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var tabs = sec.querySelectorAll('.mt-esc__tab');
      var escenas = sec.querySelectorAll('.mt-esc__escena');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
          escenas.forEach(function (s) { s.classList.remove('mt-activa'); });
          tab.setAttribute('aria-selected', 'true');
          if (escenas[i]) escenas[i].classList.add('mt-activa');
        });
      });
    });
  }

  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('[data-mt-hs]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var puntos = sec.querySelectorAll('.mt-hs__punto');
      var items = sec.querySelectorAll('.mt-hs__item');
      var activar = function (i) {
        puntos.forEach(function (p, j) { p.classList.toggle('mt-activo', i === j); });
        items.forEach(function (it, j) { it.classList.toggle('mt-activo', i === j); });
      };
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      items.forEach(function (it, i) { it.addEventListener('click', function () { activar(i); }); it.addEventListener('mouseenter', function () { activar(i); }); });
      activar(0);
    });
  }

  function initPasosTabs(raiz) {
    (raiz || document).querySelectorAll('[data-mt-pt]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var pasos = sec.querySelectorAll('.mt-pt__paso');
      var imgs = sec.querySelectorAll('.mt-pt__visor img');
      var dur = (parseFloat(sec.dataset.mtDur) || 5) * 1000;
      var actual = 0, timer = null;
      var mostrar = function (i) {
        actual = i;
        pasos.forEach(function (p, j) { p.classList.remove('mt-activo'); void p.offsetWidth; if (i === j) p.classList.add('mt-activo'); p.setAttribute('aria-selected', i === j ? 'true' : 'false'); });
        imgs.forEach(function (im, j) { im.classList.toggle('mt-activa', i === j); });
      };
      var programar = function () {
        clearInterval(timer);
        if (reducir) return;
        timer = setInterval(function () { mostrar((actual + 1) % pasos.length); }, dur);
      };
      pasos.forEach(function (p, i) { p.addEventListener('click', function () { mostrar(i); programar(); }); });
      mostrar(0);
      programar();
    });
  }

  function initCarruselResenas(raiz) {
    (raiz || document).querySelectorAll('[data-mt-rs]').forEach(function (sec) {
      if (sec.dataset.mtInit) return;
      sec.dataset.mtInit = '1';
      var pista = sec.querySelector('.mt-rs__pista');
      if (!pista) return;
      var paso = function () { var t = pista.querySelector('.mt-rs__tarjeta'); return t ? t.getBoundingClientRect().width + 20 : 300; };
      var mover = function (dir) {
        var fin = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4;
        if (dir > 0 && fin) pista.scrollTo({ left: 0 });
        else pista.scrollBy({ left: dir * paso() });
      };
      var izq = sec.querySelector('.mt-rs__flecha--izq');
      var der = sec.querySelector('.mt-rs__flecha--der');
      if (izq) izq.addEventListener('click', function () { mover(-1); });
      if (der) der.addEventListener('click', function () { mover(1); });
      if (sec.dataset.mtAuto === 'true' && !reducir) {
        var timer = setInterval(function () { mover(1); }, 5000);
        var parar = function () { clearInterval(timer); };
        pista.addEventListener('pointerdown', parar);
        sec.addEventListener('mouseenter', parar);
      }
    });
  }

  function initLanzamiento(raiz) {
    (raiz || document).querySelectorAll('[data-mt-lanz]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var fin = new Date(el.dataset.fin).getTime();
      var reloj = el.querySelector('.mt-lanz__reloj');
      if (isNaN(fin) || !reloj) return;
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      var pintar = function () {
        var resto = fin - Date.now();
        if (resto <= 0) { el.remove(); clearInterval(t); return; }
        var d = Math.floor(resto / 86400000), h = Math.floor(resto / 3600000) % 24, m = Math.floor(resto / 60000) % 60, s = Math.floor(resto / 1000) % 60;
        reloj.textContent = (el.dataset.txtReloj || '') + ' ' + d + 'd ' + dos(h) + 'h ' + dos(m) + 'm ' + dos(s) + 's';
      };
      var t = setInterval(pintar, 1000);
      pintar();
    });
  }

  function initTodo(e) {
    var r0 = e && e.target && e.target.querySelectorAll ? e.target : document;
    initLanzamiento(r0);
    initCarruselResenas(r0);
    initEscenarios(r0);
    initHotspots(r0);
    initPasosTabs(r0);
    var raiz = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(raiz);
    initComparadores(raiz);
    initCalculadoras(raiz);
    initFaq(raiz);
    initProducto(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
